export default __webpack_public_path__ + "static/media/distribute_delivery.be13a38b.gif";